// extracted by mini-css-extract-plugin
export default {"card":"liveCampaign--card--r_ntVclm","statCol":"liveCampaign--statCol--itgRv_wD","liveBadge":"liveCampaign--liveBadge--ssToQMbP"};